import axios from 'axios';
import {
  MODIFIERS,
  V1_MODIFIER,
  MODIFIER_BY_ID,
  V1_DELETE_MODIFIER,
  V1_APPLY_TO_ITEMS,
  V1_SHOW_ITEM_MODIFIER,
  CREATE_ALL_OUTLET,
  GET_MODIFIERS_LIST,
  GET_INGREDIENTS_LIST,
  ErrorCode,
} from './constants';

function commonReject(error) {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      if (data.errors[0]) {
        eobj = new Error(data.errors[0].user_message);
      } else {
        eobj = new Error(data.errors);
      }
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
}

export function getModifiers(params) {
  return axios
    .get(MODIFIERS, { withCredentials: true, params })
    .catch(commonReject);
}

export function getModifiersV1() {
  return axios.get(V1_MODIFIER, { withCredentials: true }).catch(commonReject);
}

export function getModifierById(id, params?) {
  return axios
    .get(MODIFIER_BY_ID(id), { params, withCredentials: true })
    .catch(commonReject);
}

export function postModifier(data, params?) {
  return axios
    .post(V1_MODIFIER, data, { params, withCredentials: true })
    .catch(commonReject);
}

export function deleteModifier(id, params?) {
  return axios
    .delete(V1_DELETE_MODIFIER(id), { params, withCredentials: true })
    .catch(commonReject);
}

export function putModifier(id, data, params?) {
  return axios
    .put(MODIFIER_BY_ID(id), data, { params, withCredentials: true })
    .catch(commonReject);
}

export function postCreateAllOutlet(data, params?) {
  return axios
    .post(CREATE_ALL_OUTLET, data, { params, withCredentials: true })
    .catch((error) => {
      const errorCode = error?.response?.data?.code;
      const isIngredientNotFoundError =
        errorCode === ErrorCode.ALL_OUTLET_INGREDIENT_NOT_FOUND;

      if (isIngredientNotFoundError) {
        return Promise.reject(
          new Error(ErrorCode.ALL_OUTLET_INGREDIENT_NOT_FOUND)
        );
      }

      return commonReject(error);
    });
}

export function postApplyToItems(modifierId, data, params?) {
  return axios
    .post(V1_APPLY_TO_ITEMS(modifierId), data, {
      params,
      withCredentials: true,
    })
    .catch(commonReject);
}

export function getShowItemModifer(modifierId, params) {
  return axios
    .get(V1_SHOW_ITEM_MODIFIER(), { params, withCredentials: true })
    .catch(commonReject);
}

export function getModifiersList(params) {
  return axios
    .get(GET_MODIFIERS_LIST, { withCredentials: true, params })
    .catch(commonReject);
}

export function getIngredientsList(params) {
  const { page, per_page, keyword, type } = params;
  return axios
    .get(GET_INGREDIENTS_LIST, {
      withCredentials: true,
      params: {
        page,
        per_page,
        keyword,
        type,
      },
    })
    .catch(commonReject);
}
